/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Tab, Tabs, Spinner, Table , Dropdown} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./WatcherDashBoard.scss";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import EmptyFeedCard from "../../../_uiComponents/EmptyFeedCard";
import { Link } from "react-router-dom";
import MainLayout from "../../Common/MainLayout";
export default (props) => {

  return (
    <MainLayout activeMenuItem="home" pageName="Dashboard">
      <div className="mentor-dashboard-new position-relative">
        <div className="hiring-board">
          <div className="container">  
            <div className="border border-radius-10 h-100 mt-4 bg-white">
              <div className="d-flex align-items-center justify-content-between p-3">
                <div className="w-50 align-items-center">
                  <h3 className="w-50">Jobs 
                  <span className="p-1 ml-2 rounded-lg font-weight-medium fs-smallest border">7</span></h3>
                  <p className="fs-14 text-dark mt-2">Keep track of jobs and their status.</p>
                </div>
                <div className="right d-flex">
                  <div className="search-box input-group  align-items-center h-auto border border-radius-10 w-75">
                    <input
                      type="text"
                      className="form-control border-0 bg-transparent py-0"
                      placeholder="Search"
                    />
                    <div className="input-group-append">
                      <button className="btn p-2" type="button">
                        <img
                          src="../assets/images/search-icon.png"
                          alt="search"
                        />
                      </button>
                    </div>
                  </div>
                  <button className="btn border border-radius-10 ml-3 d-flex align-items-center text-dark">
                    <img src="/assets/images/filter-icon.png" alt="icon" className="mr-1" />Filters</button>
                </div>
              </div>
              <div className="mt-1">
                <Table responsive className="my-0 pb-1 px-3">
                  <thead className="p-3 border-bottom">
                    <tr className="text-nowrap border-0 bg-grey px-2">
                      <th className="border-bottom-0 font-weight-400 text-dark">Job Title</th>
                      <th className="border-bottom-0 font-weight-400 text-dark px-4">Status</th>
                      <th className="border-bottom-0 font-weight-400 text-dark px-4">Candidates</th>
                      <th className="border-bottom-0 font-weight-400 text-dark px-4">Skills</th>
                      <th className="border-bottom-0 font-weight-400 text-dark px-4">Posted</th>
                      <th className="border-bottom-0 font-weight-400 text-dark px-4">Action</th>
                    </tr>
                  </thead>
                  {/* {loadingCandidates ? (
                    <tbody className="">
                      <tr>
                        <td colSpan="5">
                          <div className="d-flex justify-content-center align-items-center p-4">
                            <Spinner animation="border" variant="primary" />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ) : ( */}
                  <tbody className="text-grey-4">
                    {/* {allCandidates?.results &&
                        Array.isArray(allCandidates?.results) &&
                        allCandidates.results.map((item) => ( */}
                    <tr className="rounded-lg">
                      <td className="align-middle">
                        <h3
                          className="cursor-pointer font-weight-medium mb-0 text-dark-2"
                        >
                          Product Designer
                        </h3>
                      </td>
                      <td className="align-middle mb-1 px-3">
                        <span className="custom-pills inprogress p-2">Inprogress</span>
                      </td>
                      <td className="align-middle px-4">
                        17
                      </td>
                      <td className="align-middle px-4">
                        {/* {Array.isArray(item?.skills) &&
                              item?.skills &&
                              item.skills.length
                                ? item?.skills &&
                                  Array.isArray(item?.skills) &&
                                  item.skills.map((i) => ( */}
                        <span className="bg-grey border py-1 px-2 rounded-lg mr-2 mb-2 d-inline-block">
                          html
                        </span>
                        <span className="bg-grey border py-1 px-2 rounded-lg mr-2 mb-2 d-inline-block">
                          css
                        </span>
                        <span className="bg-grey border py-1 px-2 rounded-lg mr-2 mb-2 d-inline-block">
                          Figma
                        </span>
                        {/* ))
                                : "No skills added"} */}
                      </td>
                      <td className="align-middle mb-1 px-4">
                        14 Nov 2023
                      </td>
                      <td className="align-middle px-4">
                        <Dropdown >
                          <Dropdown.Toggle variant="" className="px-2">
                            <img src="/assets/images/action-icon.png" />
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="p-3">
                            <p className="cursor-pointer">Action</p>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                    <tr className="rounded-lg">
                      <td className="align-middle">
                        <h3
                          className="cursor-pointer font-weight-medium mb-0 text-dark-2"
                        >
                          Product Designer
                        </h3>
                      </td>
                      <td className="align-middle mb-1 px-3">
                        <span className="custom-pills completed p-2">Completed</span>
                      </td>
                      <td className="align-middle px-4">
                        17
                      </td>
                      <td className="align-middle px-4">
                        {/* {Array.isArray(item?.skills) &&
                              item?.skills &&
                              item.skills.length
                                ? item?.skills &&
                                  Array.isArray(item?.skills) &&
                                  item.skills.map((i) => ( */}
                        <span className="bg-grey border py-1 px-2 rounded-lg mr-2 mb-2 d-inline-block">
                          html
                        </span>
                        <span className="bg-grey border py-1 px-2 rounded-lg mr-2 mb-2 d-inline-block">
                          css
                        </span>
                        <span className="bg-grey border py-1 px-2 rounded-lg mr-2 mb-2 d-inline-block">
                          Figma
                        </span>
                        {/* ))
                                : "No skills added"} */}
                      </td>
                      <td className="align-middle mb-1 px-4">
                        14 Nov 2023
                      </td>
                      <td className="align-middle px-4">
                        <Dropdown >
                          <Dropdown.Toggle variant="" className="px-2">
                            <img src="/assets/images/action-icon.png" />
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="p-3">
                            <p className="cursor-pointer">Action</p>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>

                    <tr className="rounded-lg">
                      <td className="align-middle">
                        <h3
                          className="cursor-pointer font-weight-medium mb-0 text-dark-2"
                        >
                          Product Designer
                        </h3>
                      </td>
                      <td className="align-middle mb-1 px-3">
                        <span className="custom-pills completed p-2">Completed</span>
                      </td>
                      <td className="align-middle px-4">
                        17
                      </td>
                      <td className="align-middle px-4">
                        {/* {Array.isArray(item?.skills) &&
                              item?.skills &&
                              item.skills.length
                                ? item?.skills &&
                                  Array.isArray(item?.skills) &&
                                  item.skills.map((i) => ( */}
                        <span className="bg-grey border py-1 px-2 rounded-lg mr-2 mb-2 d-inline-block">
                          html
                        </span>
                        <span className="bg-grey border py-1 px-2 rounded-lg mr-2 mb-2 d-inline-block">
                          css
                        </span>
                        <span className="bg-grey border py-1 px-2 rounded-lg mr-2 mb-2 d-inline-block">
                          Figma
                        </span>
                        {/* ))
                                : "No skills added"} */}
                      </td>
                      <td className="align-middle mb-1 px-4">
                        14 Nov 2023
                      </td>
                      <td className="align-middle px-4">
                        <Dropdown >
                          <Dropdown.Toggle variant="" className="px-2">
                            <img src="/assets/images/action-icon.png" />
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="p-3">
                            <p className="cursor-pointer">Action</p>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                    {/* ))} */}
                  </tbody>
                  {/* )} */}
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};
